import { render } from "./dialogCanvasTxt.vue?vue&type=template&id=32149497"
import script from "./dialogCanvasTxt.vue?vue&type=script&lang=js"
export * from "./dialogCanvasTxt.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__